"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productValidationService = void 0;
var ProductValidationService_1 = require("./implementation/ProductValidationService");
exports.productValidationService = new ProductValidationService_1.ProductValidationService();
//# sourceMappingURL=index.js.map